module.exports = __webpack_public_path__ + "img/23.541f96bb.png";